import { DetailsProvider } from '../../../context/details';
import { Details } from './Details';

export const DetailsComponent = () => {
  return (
    <DetailsProvider>
      <Details />
    </DetailsProvider>
  )
}

export { DetailsComponent as Details };
